<script setup lang="ts">
import { useTheme } from "@/composable/useTheme";
import { useCreateEventLog } from "@/stores/queries";
import { EventType } from "@/types";
import { onBeforeUnmount, onMounted } from "vue";
import { useCanvasOverlayTheme } from "@/composable/useCanvasOverlayTheme";
import { areToastsMutedOnCanvas } from "@/composable/useToast";

import { useLanguage } from "@/composable/useLanguage";

useLanguage();

const { createEvent } = useCreateEventLog();
useTheme("light");
// Modales, toasts et menus (montés dans <body>) en sombre, comme l'outil
useCanvasOverlayTheme();
onMounted(() => {
  createEvent(EventType.USE_DRAWING_CANVA);
  // Aucun toast dans l'outil dessin, hors téléchargement / export (cf. useToast)
  areToastsMutedOnCanvas.value = true;
});
onBeforeUnmount(() => {
  areToastsMutedOnCanvas.value = false;
});
</script>

<template>
  <div class="canva-layout">
    <RouterView></RouterView>
  </div>
</template>

<style lang="scss">
#app {
  height: 100% !important;
}

body {
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
}
</style>

<style lang="scss" scoped>
// from https://github.com/playcanvas/editor/issues/160
@mixin disableTouchCallout() {
  // disable callout menu on webkit
  -webkit-touch-callout: none;
  // disable highlight effect on webkit
  -webkit-tap-highlight-color: transparent;
  // disable user selection
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.canva-layout {
  height: 100%;
  @include disableTouchCallout;

  :deep(*:not(.design-button)) {
    @include disableTouchCallout;
  }
}
</style>
